import {themes} from "../../../styles/themes";
import {
  getPartidoInfo,
  tooltipPartidoYDato,
  getLogo,
  getCamaraInfo,
} from "../../../commons/js/util";
import "echarts/lib/component/tooltip";
import "echarts/lib/chart/bar";
import "echarts/lib/component/title";
import { curulesEleccion } from "../../../resources/constantes.json";

const getData = (camara, eleccion, nomenclator, t) => {
  let parsedData;
  const convocatoria = "act";
  const sinInfo = Number(camara.cargtota) === 0;
  const sinInfoData =  {
    name: t("sinAsignar"),
    value: curulesEleccion[eleccion],
    itemStyle: {
      borderColor: themes.color.sinInfo,
      color: themes.color.sinInfo,
    },
    tipData: {
      showTooltip: true,
      sinInfo: true,
      noModal: true,
    },
    emphasis: {
      show: false,
      itemStyle: {
        borderColor: themes.color.sinInfo,
        color: themes.color.sinInfo,
      },
    },
  };

  if (sinInfo) {
    parsedData = [
      sinInfoData
    ];
  } else {
    parsedData = [];
    let item;
    const partidos = camara.partotabla.filter(p => p[convocatoria].cargElectos !== '0')
    for (let index = 0; index < partidos.length; index++) {
        const partido = partidos[index][convocatoria];
        const par = getPartidoInfo(
            partido.codpar,
            nomenclator.partidos
        );
        item = {
          name: par.nombre,
          value: Number(partido.cargElectos),
          cursor: "pointer",
          vot: partido.vot,
          dataTestId: `data.partotabla[${index}].${convocatoria}.cargElectos`,
          itemStyle: {
            borderColor: "#fff",
            color: par.color,
          },
          tipData: {
            tipoCargo:
              Number(partido.cargElectos) === 1 ? t("curul") : t("curules"),
            showTooltip: true,
            codpar: par.codpar,
            parName: par.nombre,
            convocatoria,
          },
        };
        
        parsedData.push(item);
    }
    /** Añadimos los cargos sin asignar por camara */
    const sinAsignarCamara = Number(camara.cargtota) - Number(camara.cargElectos);
    const sinAsignar = {
      name: t("sinAsignar"),
      value: sinAsignarCamara,
      itemStyle: {
        borderColor: themes.color.sinAsignar,
        color: themes.color.sinAsignar,
      },
      tipData: {
        tipoCargo: sinAsignarCamara === 1 ? t("curul") : t("curules"),
        showTooltip: true,
        noModal: true,
      },
    };
    parsedData.push(sinAsignar);
    if(partidos.length === 0){
      parsedData = [
        sinInfoData
      ];
    }
  }
  return parsedData;
};

export function getOption(camaraSeleccionada, nomenclator, eleccion, isSmall, isDesktop, t, lang) {
  const data = getData(camaraSeleccionada, eleccion, nomenclator, t);
  
  const option = {
    tooltip: {
      show: isDesktop,
      trigger: "item",
      confine: true,
      padding: 0,
      formatter: function(params) {
        let result;
        const data = params.data;
        if (data && data.tipData.showTooltip)
          if (!data.tipData.sinInfo)
            result = tooltipPartidoYDato(
              null,
              data.tipData.color ?? data.itemStyle.color,
              data.name,
              data.value,
              data.tipData.tipoCargo,
              null,
              null,
              null,
              null,
              getLogo(data.tipData.codpar, lang, data.tipData.convocatoria)
            );
          else
            result = tooltipPartidoYDato(
              null,
              data.itemStyle.color,
              data.name
            );
        return result;
      },
    },
    series: [
      {
        name: 'Curules',
        type: 'pie',
        radius: ['50%', '70%'],
        avoidLabelOverlap: true,
        label: {
          color: '#000',
          fontSize: '40',
          position: 'center',
          formatter: () => {
            return camaraSeleccionada.cargtota || 0; 
          },
        },
        labelLine: {
          show: false,
        },
        data: data,
      },
    ],
  };
  return option;
}

